import { scrollBehavior } from './preferences.js'

/**
 * Pages scroll inside <main> (body is overflow-hidden), and the browser's own
 * jump to a URL's #fragment happens before the CSS and icons loaded by
 * main.js have laid the page out, so it lands at the top instead, e.g. the
 * profile's link to /how-to-play/#streaks. Scroll to the target again once
 * the page has loaded, unless the visitor has already started scrolling.
 */
let visitorScrolled = false
// Only input that actually scrolls counts, so a tap or a Tab to the next
// link while the page loads doesn't cancel the jump.
const SCROLL_KEYS = new Set([
    'ArrowUp',
    'ArrowDown',
    'PageUp',
    'PageDown',
    'Home',
    'End',
    ' ',
])
const SCROLL_INPUTS = ['wheel', 'touchmove', 'keydown']
const onScrollInput = (event) => {
    if (event.type === 'keydown' && !SCROLL_KEYS.has(event.key)) return
    visitorScrolled = true
}
SCROLL_INPUTS.forEach((type) =>
    window.addEventListener(type, onScrollInput, { passive: true })
)

const hashTarget = () => {
    try {
        const id = decodeURIComponent(window.location.hash.slice(1))
        return id ? document.getElementById(id) : null
    } catch {
        // A malformed hash (e.g. #%E0) can't name an element
        return null
    }
}

const scrollToHashTarget = () => {
    SCROLL_INPUTS.forEach((type) =>
        window.removeEventListener(type, onScrollInput)
    )
    const target = hashTarget()
    if (!target || visitorScrolled) return

    // container: scroll <main> only, not the page around it (where supported)
    target.scrollIntoView({
        behavior: scrollBehavior(),
        container: 'nearest',
    })
}

if (document.readyState === 'complete') {
    scrollToHashTarget()
} else {
    window.addEventListener('load', scrollToHashTarget, { once: true })
}
